import { Component, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-dialog-subtitle',
  templateUrl: './subtitle.component.html'
})
export class DialogSubtitleComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-dialog-subtitle]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-dialog-subtitle modal-subtitle'
  }
})
export class DialogHeadingSubtitleComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
